import React from 'react';
import { useFetch, fmtDate, roleStyles } from '../utils';
import { adminApi } from '../api';
import { Section } from '../_primitives/Section';
import { DataTable, type Column } from '../_primitives/DataTable';
import { KantorenHeatmap } from '../KantorenHeatmap';
import type { KantoorRow } from '../types';

const cols: Column<KantoorRow>[] = [
  { key: 'company_name', label: 'Bedrijf', sortValue: (k) => k.company_name ?? '', searchValue: (k) => k.company_name ?? '',
    render: (k) => <span className="font-medium text-ink dark:text-white truncate max-w-[24ch] inline-block" title={k.company_name ?? ''}>{k.company_name ?? '—'}</span> },
  { key: 'email', label: 'Email', sortValue: (k) => k.email, searchValue: (k) => k.email,
    render: (k) => <span className="text-ink/75 dark:text-white/75">{k.email}</span> },
  { key: 'subscription_plan', label: 'Plan', sortValue: (k) => k.subscription_plan ?? '',
    render: (k) => <span className="text-ink/65 dark:text-white/65">{k.subscription_plan ?? '—'}</span> },
  { key: 'role', label: 'Rol', sortValue: (k) => k.role,
    render: (k) => <span className={`inline-flex items-center text-[11px] font-semibold px-2 py-0.5 rounded-md ${roleStyles[k.role] ?? roleStyles.medewerker}`}>{k.role}</span> },
  { key: 'credits', label: 'Credits', align: 'right', sortValue: (k) => k.credits,
    render: (k) => <span className="font-mono text-ink/75 dark:text-white/75">{k.credits}</span> },
  { key: 'created_at', label: 'Aangemaakt', sortValue: (k) => k.created_at,
    render: (k) => <span className="text-ink/55 dark:text-white/55">{fmtDate(k.created_at)}</span> },
  { key: 'last_login', label: 'Laatste login', sortValue: (k) => k.last_login ?? '',
    render: (k) => <span className="text-ink/55 dark:text-white/55">{fmtDate(k.last_login)}</span> },
];

export const KantorenTab: React.FC = () => {
  const { data, loading, error, refresh } = useFetch(adminApi.kantoren);
  const rows = data ?? [];

  const friendlyError = error
    ? 'Er ging iets mis bij het laden van kantoren. Probeer het opnieuw.'
    : null;

  return (
    <div className="space-y-4">
      <KantorenHeatmap rows={rows} />
      <Section title={`Kantoren (${rows.length})`}>
        <DataTable
          rows={rows}
          loading={loading}
          error={friendlyError}
          onRetry={refresh}
          columns={cols}
          rowKey={(k) => k.id}
          searchPlaceholder="Zoek op bedrijf, email, plan…"
        />
      </Section>
    </div>
  );
};
